module.exports = __webpack_public_path__ + "static/media/katherinechen.6448fa12.jpeg";